import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpendLensCategoryResponseModel } from '@/types/clarityLens'

export const getSpendLensSubCategories = async (
  branchName: string,
  startDate: string,
  endDate: string,
  parentCategory: string
): Promise<SpendLensCategoryResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/spend-lens/sub-categories`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        dcn: branchName,
        parent_category: parentCategory,
      },
    })

    return response.data?.sub_categories
  } catch (error) {
    throw error
  }
}
